import {
    SET_DRAWER_OPENED,
} from '../../../constants/ActionTypes';
import drawerInitialState from './drawerInitialState';

function drawerReducer(state = drawerInitialState, action) {
    switch (action.type) {
    case SET_DRAWER_OPENED:
        return {
            drawerOpened: action.drawerOpened,
        };
    default:
        return state;
    }
}

export default drawerReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/Drawer/drawerReducer.js